import { Launcher } from "../../entities/launcher.type";
import { PlaylistItemDTO } from "./playlist-item-dto.model";

export class PlaylistItemChangeSourceModel {
  item: PlaylistItemDTO;
  sourceId: number;
  mclMode: string;
  event: Event;
  launcher: Launcher;
}
